import common from './resources/common/common.en';

export default { common };
